import { CommonModule } from '@angular/common';
import { Component, EnvironmentInjector, Inject, Input } from '@angular/core';
import { ReactiveFormsModule, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { Modal, ModalOptions } from '@indice/ng-components';
import { TranslocoDirective, TranslocoPipe } from '@jsverse/transloco';
import { catchError, EMPTY, tap } from 'rxjs';
import { AuthService } from 'src/app/core/services/auth.service';
import { IAsideModalResponse } from 'src/app/features/property-details/aside-content/aside-content.component';
import { HttpValidationProblemDetails, PropertyDetails } from 'src/app/services/portal-api.service';
import { WorkflowApiService } from 'src/app/services/workflow.service';
import { RequestsUnauthorizedComponent, UnauthorizedRequestsTranslationSuffix } from '../requests-unauthorized/requests-unauthorized.component';

@Component({
  selector: 'app-request-callback-modal',
  standalone: true,
  imports: [ReactiveFormsModule, CommonModule, RequestsUnauthorizedComponent, TranslocoDirective, TranslocoPipe],
  templateUrl: './request-callback-modal.component.html'
})
export class RequestCallbackModalComponent {

  @Input() property: PropertyDetails | undefined;

  @Input() isLoggedIn: boolean = false;

  public unauthorizedSuffix: UnauthorizedRequestsTranslationSuffix = UnauthorizedRequestsTranslationSuffix.REQUEST_CALLBACK;

  protected processingRequest: boolean = false;

  form = new UntypedFormGroup({
    message: new UntypedFormControl(''),
  });

  constructor(
    public modalRef: Modal, 
    @Inject(ModalOptions) private _options: ModalOptions, 
    private _authService: AuthService, 
    private _workflowApi: WorkflowApiService,
    @Inject(EnvironmentInjector) private envInjector: EnvironmentInjector,) { }

  ngOnInit(): void {
    this.property = (this._options?.initialState?.['property'] as PropertyDetails);
    this.isLoggedIn = (this._options?.initialState?.['isLoggedIn'] as boolean);
  }

  close = () => this.modalRef.hide({ name: this.form.get('message')?.value });

  sendRequest = () => {
    this.processingRequest = true;
    this._workflowApi.initiateCallback({
      propertyId: this.property?.id ?? undefined,
      userMessage: this.form.get('message')?.value,
      preferredContactDate: undefined,
    }).pipe(
      catchError((error: any) => {
        let errorBody = undefined;
        if (error instanceof HttpValidationProblemDetails) {
          if (error.errors) {
            errorBody = Object.entries(error.errors)
              .map(m => m[1])
              .flat()
              .join(', ');
          }
        }
        let rs: IAsideModalResponse = {
          success: false,
          errorDesc: errorBody,
        };
        this.modalRef.hide(rs);

        return EMPTY;
      }),
      tap((t) => {
        let rs: IAsideModalResponse = {
          success: true,
        };
        this.modalRef.hide(rs);
      })
    ).subscribe();
  }

  login() {
    this._authService.signinRedirect(`/properties/${this.property?.code}`);
  }

  signUp() {
    this._authService.signinRedirect(`/home?action=callback&propertyId=${this.property?.id}`, { operation: 'register' });
  }
}
